import { _ as _defineProperty } from '../unsorted/defineProperty.js';
import { _ as _toConsumableArray } from '../unsorted/toConsumableArray.js';
import { _ as _typeof } from '../unsorted/typeof.js';
import { m as merge } from '../unsorted/index.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function isError(key) {
  return _typeof(key) === "object" && key !== null && "_error" in key;
}
var DEFAULT_TEXT_SIZES = {
  heading: "medium",
  body: "medium",
  caption: "medium"
};
var DEFAULT_TEXT_WEIGHTS = {
  heading: "regular",
  body: "regular",
  caption: "regular"
};
function renderResponsiveTextStyles(_ref) {
  var _sizeAsArray$shift, _weightAsArray$shift;
  var size = _ref.size,
    weight = _ref.weight,
    tokenTextComponent = _ref.tokenTextComponent,
    themeProps = _ref.themeProps;
  var sizeAsArray = Array.isArray(size) ? _toConsumableArray(size) : [size];
  var weightAsArray = Array.isArray(weight) ? _toConsumableArray(weight) : [weight];

  // We need to convince TS that the default values are a subset of the types in sizeAsArray and weightAsArray
  var defaultSize = (_sizeAsArray$shift = sizeAsArray.shift()) !== null && _sizeAsArray$shift !== void 0 ? _sizeAsArray$shift : DEFAULT_TEXT_SIZES[tokenTextComponent];
  var defaultWeight = (_weightAsArray$shift = weightAsArray.shift()) !== null && _weightAsArray$shift !== void 0 ? _weightAsArray$shift : DEFAULT_TEXT_WEIGHTS[tokenTextComponent];
  var sizeStyles = merge.apply(void 0, _toConsumableArray(sizeAsArray.map(function (responsiveSize, index) {
    if (responsiveSize != null && !isError(responsiveSize)) {
      var _themeProps$base$brea;
      var mediaStyleRule = "@media screen and (min-width: ".concat((_themeProps$base$brea = themeProps.base.breakpointAsArray) === null || _themeProps$base$brea === void 0 ? void 0 : _themeProps$base$brea[index], "px)");
      return _defineProperty({}, mediaStyleRule, {
        fontSize:
        // @NOTE: TS isn't smart enough to infer past the second level, so we need to cast here. Matt Pocock approved, we promise!
        themeProps.base.text[tokenTextComponent][responsiveSize].regular.fontSize,
        lineHeight: themeProps.base.text[tokenTextComponent][responsiveSize].regular.lineHeight
      });
    }
    return {};
  })));
  var weightStyles = merge.apply(void 0, _toConsumableArray(weightAsArray.map(function (responsiveWeight, index) {
    var _sizeAsArray$index;
    var responsiveSize = (_sizeAsArray$index = sizeAsArray[index]) !== null && _sizeAsArray$index !== void 0 ? _sizeAsArray$index : defaultSize;
    if (responsiveWeight != null && !isError(responsiveSize) && !isError(responsiveWeight)) {
      var _themeProps$base$brea2;
      var mediaStyleRule = "@media screen and (min-width: ".concat((_themeProps$base$brea2 = themeProps.base.breakpointAsArray) === null || _themeProps$base$brea2 === void 0 ? void 0 : _themeProps$base$brea2[index], "px)");
      return _defineProperty({}, mediaStyleRule, {
        fontWeight: themeProps.base.text[tokenTextComponent][responsiveSize][responsiveWeight].fontWeight
      });
    }
    return {};
  })));
  var styles = merge({}, sizeStyles, weightStyles);
  return {
    defaultSize: defaultSize,
    defaultWeight: defaultWeight,
    styles: styles
  };
}
function getBodyTextStyles(_ref4) {
  var size = _ref4.size,
    weight = _ref4.weight,
    themeProps = _ref4.themeProps,
    mono = _ref4.mono;
  var _renderResponsiveText = renderResponsiveTextStyles({
      tokenTextComponent: "body",
      size: size,
      weight: weight,
      themeProps: themeProps
    }),
    defaultSize = _renderResponsiveText.defaultSize,
    defaultWeight = _renderResponsiveText.defaultWeight,
    responsiveStyles = _renderResponsiveText.styles;
  return _objectSpread(_objectSpread({
    fontFamily: mono ? themeProps.base.font.family.body.secondary : themeProps.base.font.family.body.primary,
    fontSize: themeProps.base.text.body[defaultSize].regular.fontSize,
    lineHeight: themeProps.base.text.body[defaultSize].regular.lineHeight,
    fontWeight: themeProps.base.text.body[defaultSize][defaultWeight].fontWeight,
    textTransform: "none",
    letterSpacing: "unset"
  }, responsiveStyles), {}, {
    "&::selection": {
      backgroundColor: themeProps.base.color.text.highlight
    }
  });
}
function getCaptionTextStyles(_ref5) {
  var size = _ref5.size,
    weight = _ref5.weight,
    themeProps = _ref5.themeProps;
  var _renderResponsiveText2 = renderResponsiveTextStyles({
      tokenTextComponent: "caption",
      size: size,
      weight: weight,
      themeProps: themeProps
    }),
    defaultSize = _renderResponsiveText2.defaultSize,
    defaultWeight = _renderResponsiveText2.defaultWeight,
    responsiveStyles = _renderResponsiveText2.styles;
  return _objectSpread(_objectSpread({
    fontFamily: themeProps.base.font.family.body.primary,
    fontSize: themeProps.base.text.caption[defaultSize].regular.fontSize,
    lineHeight: themeProps.base.text.caption[defaultSize].regular.lineHeight,
    fontWeight: themeProps.base.text.caption[defaultSize][defaultWeight].fontWeight,
    textTransform: themeProps.base.text.caption[defaultSize][defaultWeight].casing,
    letterSpacing: themeProps.base.text.caption[defaultSize][defaultWeight].letterSpacing
  }, responsiveStyles), {}, {
    "&::selection": {
      backgroundColor: themeProps.base.color.text.highlight
    }
  });
}
function getHeadingTextStyles(_ref6) {
  var size = _ref6.size,
    weight = _ref6.weight,
    themeProps = _ref6.themeProps;
  var _renderResponsiveText3 = renderResponsiveTextStyles({
      tokenTextComponent: "heading",
      size: size,
      weight: weight,
      themeProps: themeProps
    }),
    defaultSize = _renderResponsiveText3.defaultSize,
    defaultWeight = _renderResponsiveText3.defaultWeight,
    responsiveStyles = _renderResponsiveText3.styles;
  return _objectSpread(_objectSpread({
    fontFamily: themeProps.base.font.family.heading.primary,
    fontSize: themeProps.base.text.heading[defaultSize].regular.fontSize,
    lineHeight: themeProps.base.text.heading[defaultSize].regular.lineHeight,
    fontWeight: themeProps.base.text.heading[defaultSize][defaultWeight].fontWeight,
    textTransform: "none",
    letterSpacing: "unset"
  }, responsiveStyles), {}, {
    "&::selection": {
      backgroundColor: themeProps.base.color.text.highlight
    }
  });
}

export { getBodyTextStyles, getCaptionTextStyles, getHeadingTextStyles, isError, renderResponsiveTextStyles };
//# sourceMappingURL=textStyleHelpers.js.map
